import React from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { Grid } from '@fuww/library/src/Grid';
import MediumCard from '@fuww/library/src/Cards/Medium';
import Premium from '@fuww/library/src/Icons/Premium';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import ImageWithUrls from '../ImageWithUrls';
import loadMore from '../../lib/queries/loadMore';
import LoadMore from '../LoadMore';
import ListItemWrapper from './ListItemWrapper';

const CardList = ({
  searchVariables,
  fetchMore,
  field,
  data,
  listItems,
  loading,
  route,
}) => {
  const theme = useTheme();
  const {
    edges,
    pageInfo: { hasNextPage },
  } = listItems;

  return (
    <>
      <Grid>
        {edges.map((edge) => {
          const { node } = edge;
          const {
            id,
            company: {
              fullName,
              logoUrls,
            },
            page: {
              about,
              slug,
              imageUrls: originalImageUrls,
              premium,
            },
          } = node;
          const imageUrls = originalImageUrls[0] ? originalImageUrls : logoUrls;

          return (
            <ListItemWrapper
              key={id}
              params={{ slug }}
              slug={slug}
              route={route}
            >
              <MediumCard
                image={imageUrls[0] && (
                  <ImageWithUrls
                    sizes={`
                      (min-width: ${breakpoints.lg}px) 318px,
                      (min-width: ${breakpoints.md}px) 23vw,
                      (min-width: ${breakpoints.sm}px) 45vw,
                      94vw
                    `}
                    imageUrls={imageUrls}
                    alt={fullName}
                    srcSet={`${imageUrls[1]
                    } 318w, ${imageUrls[2]
                    } 636w, ${imageUrls[3]
                    } 960w`}
                  />
                )}
                logoLetterbox={!originalImageUrls[0]}
                title={fullName}
                description={about}
                icon={premium && (
                  <Premium
                    fillColor={theme.colors?.primary}
                  />
                )}
                withPageMargins
              />
            </ListItemWrapper>
          );
        })}
      </Grid>
      <LoadMore
        hasNextPage={hasNextPage}
        loading={loading}
        fetchMore={
          () => loadMore({ searchVariables })(data, field, fetchMore)
        }
      />
    </>
  );
};

CardList.propTypes = {
  searchVariables: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  fetchMore: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  listItems: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({})),
    pageInfo: PropTypes.shape({ hasNextPage: PropTypes.bool }),
  }).isRequired,
  field: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
};

CardList.defaultProps = {
  data: {},
};

export default CardList;
